import { bindActionCreators } from 'redux';
import {
  getDataReport, appealDataReport
} from '../../../../redux/actions/mvp/session.action';
import { connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import { I18n } from '../../../../helpers/i18n';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './detail.scss';

function AppealDetail({
    history,
    match,
    header,
    footer,
    getDataReport,
    appealDataReport
}) {
  const appealId = match.params.id;
  const [appealInfo, setAppealInfo] = useState(null);
  const [errorData, setErrorData] = useState(null);
  const [appealReason, setAppealReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (!appealId) return;

    getDataReport(appealId)
      .then((response) => {
        setAppealInfo(response.data);
        setErrorData(response.errorData);
      })
      .catch((error) => {
        console.error('Error fetching report:', error);
        setErrorData(error);
      });
  }, [appealId, getDataReport])

  const getStatusText = (status) => {
    switch (status) {
      case 'approved':
        return I18n.t('appeal_status_approved');
      case 'rejected':
        return I18n.t('appeal_status_rejected');
      case 'pending':
        return I18n.t('appeal_status_pending');
      case 'processed':
        return I18n.t('appeal_status_processed');
      default:
        return status;
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'approved':
        return { color: '#25D076' };
      case 'rejected':
        return { color: '#FF445D' };
      case 'pending':
        return { color: '#E87623' };
      case 'processed':
        return { color: '#2aa58e' };
      default:
        return { color: '#FFFFFF' };
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!appealReason.trim()) {
      toast.error(I18n.t('text_field_required_error'));
      return;
    }

    setIsSubmitting(true);
    appealDataReport({appealId, appealReason})
      .then((response) => {
        toast.success(I18n.t('appeal_submit_success'));
        // Redirect to home page after showing toast
        setTimeout(() => {
          history.push('/');
        }, 1500);
      })
      .catch((error) => {
        console.error('Error submitting appeal:', error);
        toast.error(error?.msg || I18n.t('something_wrong'));
        setIsSubmitting(false);
      });
  };

  return (
    <div id="site_wrapper">
      <div>{header}</div>
      <main className="main" ref={scrollRef}>
        <div className="container">
          {errorData && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '60vh',
              textAlign: 'center'
            }}>
              <p style={{
                color: 'red',
                fontSize: '24px',
                fontWeight: 'bold'
              }}>
                {errorData?.msg}
              </p>
            </div>
          )}

          {!errorData && appealInfo && (
            <div className="detail-session">
              <h1 className="title">{I18n.t('appeal_detail_title')}</h1>

              <div style={{
                marginTop: '40px',
                padding: '24px',
                border: '1px solid #8c8c8c',
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.05)'
              }}>
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{
                    color: '#FFFFFF',
                    fontSize: '18px',
                    fontWeight: '600',
                    marginBottom: '8px'
                  }}>
                    {I18n.t('appeal_content_title')}:
                  </h3>
                  <p style={{
                    color: '#FFFFFFB2',
                    fontSize: '16px',
                    marginBottom: '0'
                  }}>
                    {appealInfo.contentTitle}
                  </p>
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{
                    color: '#FFFFFF',
                    fontSize: '18px',
                    fontWeight: '600',
                    marginBottom: '8px'
                  }}>
                    {I18n.t('appeal_rule_section')}:
                  </h3>
                  <p style={{
                    color: '#FFFFFFB2',
                    fontSize: '16px',
                    marginBottom: '0'
                  }}>
                    {appealInfo.ruleSection}
                  </p>
                </div>

                {appealInfo.adminNote && (
                  <div style={{ marginBottom: '24px' }}>
                    <h3 style={{
                      color: '#FFFFFF',
                      fontSize: '18px',
                      fontWeight: '600',
                      marginBottom: '8px'
                    }}>
                      {I18n.t('appeal_admin_note')}:
                    </h3>
                    <p style={{
                      color: '#FFFFFFB2',
                      fontSize: '16px',
                      marginBottom: '0'
                    }}>
                      {appealInfo.adminNote}
                    </p>
                  </div>
                )}

                <div>
                  <h3 style={{
                    color: '#FFFFFF',
                    fontSize: '18px',
                    fontWeight: '600',
                    marginBottom: '8px'
                  }}>
                    {I18n.t('appeal_status')}:
                  </h3>
                  <p style={{
                    fontSize: '16px',
                    marginBottom: '0',
                    fontWeight: '600',
                    ...getStatusStyle(appealInfo.status)
                  }}>
                    {getStatusText(appealInfo.status)}
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} style={{ marginTop: '40px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{
                    display: 'block',
                    color: '#FFFFFF',
                    fontSize: '18px',
                    fontWeight: '600',
                    marginBottom: '12px'
                  }}>
                    {I18n.t('appeal_reason_label')}:
                  </label>
                  <textarea
                    value={appealReason}
                    onChange={(e) => setAppealReason(e.target.value)}
                    placeholder={I18n.t('appeal_reason_hint')}
                    rows={6}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      fontSize: '16px',
                      color: '#FFFFFF',
                      backgroundColor: 'rgba(255, 255, 255, 0.05)',
                      border: '1px solid #8c8c8c',
                      borderRadius: '8px',
                      resize: 'vertical',
                      fontFamily: 'inherit'
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-create-session"
                  style={{
                    width: '100%',
                    padding: '16px',
                    fontSize: '18px',
                    fontWeight: '600',
                    opacity: isSubmitting ? 0.6 : 1,
                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isSubmitting ? I18n.t('submitting') : I18n.t('appeal_submit_button')}
                </button>
              </form>
            </div>
          )}
        </div>
      </main>
    </div>
  )
}


const mapStateToProps = ({ user, mvp }) => ({
  user,
  mvp,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDataReport,
      appealDataReport
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppealDetail);
